import { ImportTypeConfig } from '#/store/hooks/useForms/Import/types/ImportTypeConfig'

export const absMonitor: ImportTypeConfig = {
  instructions: {
    software: 'ABS Monitor',
    spreadsheetName: { lower: true, messageKey: 'exportable' },
  },
  type: 'abs-monitor',
}
